<template>
    <div id="login">

		<div class="fullscreen-overlay"></div>

		<div class="container-fluid">
			<div class="row justify-content-center">

				<!-- First Column -->
				<div class="col-md-3 col-sm-12 col-xs-12 d-flex align-items-stretch" style="padding: 0px;">
					<div class="shadow" style="border-top-left-radius: 15px; border-bottom-left-radius: 15px; padding: 50px; min-height: 50vh; width: 100%;">

						<div class="pl-n5 pt-4 mb-5 text-center">
							<img src="@/assets/img/Logo/AHM Icon Logo New.png" class="pb-4 align-middle pt-5 mt-5 rounded-start img-static" style="width: 100%; max-width: 200px;"/>
						</div>
					</div>
				</div>

				<!-- Second Column -->
				<div class="col-md-3 col-sm-12 col-xs-12 d-flex align-items-stretch" style="padding: 0px;">
					<div class="shadow2" style="border-top-right-radius: 15px; border-bottom-right-radius: 15px; padding: 50px; min-height: 50vh; width: 100%;">

						<div class="mb-5">
							<h4 class="mt-1" style="font-size: 20px; color: #000000;">{{ isRegisterForm ? 'Daftar' : 'Selamat Datang!' }}</h4>
							<p class="subtitle" style="font-size: 14px; color: #848484;">{{ isRegisterForm ? 'Siapkan dan jalankan akun Anda' : 'Silahkan login untuk mengaktifkan item, memantau aktivitas Anda, mengelola produk, dan masih banyak lagi!' }}</p>
						</div>

						<form @submit.prevent="isRegisterForm ? register() : login()">
							<div class="form-group">
								<!-- <label class="labelForm">Username</label> -->
								<input type="text" class="form-control" v-model="form.username" placeholder="Username"/>
							</div>
							<div class="form-group mt-5">
								<!-- <label class="labelForm">Password</label> -->
								<!-- <input type="password" class="form-control" v-model="form.password" placeholder="Password"/> -->
								<input :type="passwordFieldType" class="form-control" v-model="form.password" placeholder="Password">
								<button @click="togglePasswordVisibility" type="button" class="toggle-password">
									<i v-if="passwordFieldType == 'password'" class="fa fa-eye"></i>
									<i v-else class="fa fa-eye-slash"></i>
								</button>
							</div>

							<div class="mb-3">
								<input type="checkbox" name="remember_me" class="" v-model="form.isRemember"> Ingatkan Saya
							</div>

							<div class="form-group text-center">
								<button class="btn ahmoil-button" type="submit">{{ isRegisterForm ? 'Daftar' : 'Login' }}</button>
							</div>
							<!-- <div class="text-center mt-4 pt-4">
								<p>{{ isRegisterForm ? 'Sudah mempunyai akun? ' : 'Tidak Punya Akun? ' }}
									<a href="#" @click="toggleForm" class="text-decoration-underline">{{ isRegisterForm ? 'Masuk' : 'Daftar' }}</a>
								</p>
							</div> -->
						</form>
					</div>
				</div>

			</div>
		</div>
		
		<div class="footerLogin">
			&copy; 2023 Qtrust, All Rights Reserved. Version {{version}}
		</div>
    </div>
</template>

<script type="text/javascript">

import PageOptions from '@/Options/PageOptions.js'
import jquery from 'jquery';
import {version} from './../../../package.json'

export default {
	metaInfo: {
		title: 'Login',
		titleTemplate: '%s - AHM Sparepart',
		htmlAttrs: {
			lang: 'en',
			amp: true
		}
	},
	name: 'Login',
	data() {
	 	return {
			form: {
				username: '',
				password: '',
				isRemember: false
			},
            isRegisterForm: false,
			error: '',
			mobile : this.isMobile(),
			version,
			passwordFieldType: 'password'

		}
	},
	methods: {
		togglePasswordVisibility() {
			this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
		},
		login: function () {
			this.$http.post('/auth/sso/login', this.form)
			.then((resp) => {
				this.error = ''
				var user = resp.data.data;

				this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;
				user.name = this.form.username

				this.$store.dispatch('setUser', user);
				localStorage.setItem('date_expired', user.token_expired);
				localStorage.setItem('isRemember', this.form.isRemember);
				this.$router.push({name : 'Highlights'})
				this.loadFilterOptions()
			})
			.then(async () => {
			})
			.catch((err) => {
				console.log(err);
				this.$swal.fire({
					title : "Error!",
					icon : "error",
					type : "error",
					text : err.response.data.message
				})
			})
		},
		register: function () {
			this.$http.post('/auth/registration', this.form)
			.then((resp) => {
				this.error = ''
				var user = resp.data.data;
				console.log(user , resp.data)

				this.$http.defaults.headers.common['Authorization'] = "Bearer " + user.token;
				user.name = this.form.username

				this.$store.dispatch('setUser', user);
				this.$router.push({name : 'Highlights'})
				this.loadFilterOptions()
			})
			.then(async () => {
			})
			.catch((err) => {
				console.log(err);
				this.$swal.fire({
					title : "Error!",
					icon : "error",
					type : "error",
					text : err.response.data.message
				})
			})
		},
        toggleForm() {
            // Toggle between login and register forms
            this.isRegisterForm = !this.isRegisterForm;
        },
	}
}
</script>

<style scoped>
	.form-group {
		position: relative;
	}

	.toggle-password {
		position: absolute;
		right: 10px;
		top: 10px;
		border: none;
		background: transparent;
		cursor: pointer;
	}
	.fullscreen-overlay {
		position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('../../assets/img/Logo/login background.png') center center no-repeat;
  background-size: cover;
  z-index: 0; /* Place it behind other content */
  opacity: 0.7; /* Adjust the opacity as needed */
	}

	#login{
		height: 100vh;
		background: linear-gradient(to right, #C00C58, #D4312D), black;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;;
		background-repeat: no-repeat;
		background-position: 50% 50%;
		background-size: 100% auto;
		position: relative;
		overflow-y: hidden;

		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.shadow{
		background: #F8F9FA;
		/* height: 10px; */
	}

	.shadow2{
		background: #fff;
		/* height: 10px; */
	}

	.h-10 {
		height: 10% !important;
	}

	.toCenter{
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.wid50{ width: 50vw; }

	.wid90{ width: 90vw; }

	#loginShade{
		position: absolute;
		top:50%; left:50%;
		transform: translate(-50%, -50%);

		height: 400px;

		margin: 0 auto;

		background-color: #000;
		opacity: 0.5;
		border-radius: 7px;
	}

	#loginBox{
		position: absolute;
		top:50%; left:50%;
		transform: translate(-50%, -50%);

		height: 400px;

		margin: 0 auto;
		padding: 2%;
		color:white;
	}

	.login-input{
		height:50px;
	}

	.login-input::placeholder{
		font-size: 130%;
		font-weight: bold;
	}

	.labelForm {
		font-size: 15px;
		font-weight: 600;
		color : #575757;
	}

	.form-control {
		border: 0;
		outline: 0;
		border-bottom: 2px solid #ddd;
		border-radius: 0;
		padding: 0;
		font-size: 1rem;
	}

	.form-control:focus {
		border: 0 !important;
		outline: 0 !important;
		box-shadow: 0 1px 1px #fff inset;
		border-bottom: 2px solid #1f6dbb !important;
		border-radius: 0;
		transition: all 0.7s ease;
	}

	.footerLogin {
		position: fixed;
		left: 50%;
		bottom: 20px;
		transform: translate(-50%, -50%);
		margin: 0 auto;
		color:grey;
		font-size:11px;
	}

	.ahmoil-button {
		width: 100%;
		height: 40px;
		background: #EC1A30;
		color: white;
		font-size: 125%;
	}

	.footerLogin {
		color : white;
	}
	
</style>